import { z } from "zod";

export const triggerValues = ["quota_progress", "target_progress", "campaign_progress"];

export const actionValues = [
  "pause_campaign",
  "pause_c_campaigns",
  "pause_adsets",
  "pause_adsets_by_audience",
  "pause_adsets_by_gender",
  "pause_adsets_by_age_range",
];

export const actionSchema = z
  .object({
    name: z.string().optional().nullable(),
    active: z.boolean().optional(),
    run_only_once: z.boolean().optional(),
    trigger: z.enum(triggerValues),
    progress: z
      .number({ invalid_type_error: "Please input a number" })
      .int("Please input an integer")
      .min(1, "Please input a value greater than 0"),
    action: z.enum(actionValues),
    survey_target_id: z.union([z.string(), z.number()]).nullable().optional(),
    quota_id: z.union([z.string(), z.number()]).nullable().optional(),
    c_campaigns: z.array(z.union([z.string(), z.number()])).default([]),
    adsets: z.array(z.union([z.string(), z.number()])).default([]),
    audiences: z.array(z.union([z.string(), z.number()])).default([]),
    gender: z.string().optional(),
    age_min: z.number().int().nullable().optional(),
    age_max: z.number().int().nullable().optional(),
  })
  .superRefine((d, ctx) => {
    if (["quota_progress", "target_progress"].includes(d.trigger) && !d.survey_target_id) {
      ctx.addIssue({ code: "custom", path: ["survey_target_id"], message: "Please select a target" });
    }
    if (d.trigger === "quota_progress" && d.survey_target_id && !d.quota_id) {
      ctx.addIssue({ code: "custom", path: ["quota_id"], message: "Please select a quota" });
    }
    if (["pause_c_campaigns", "pause_adsets", "pause_adsets_by_audience"].includes(d.action) && !d.c_campaigns.length) {
      ctx.addIssue({ code: "custom", path: ["c_campaigns"], message: "Please select at least one campaign" });
    }
    if (d.action === "pause_adsets" && !d.adsets.length) {
      ctx.addIssue({ code: "custom", path: ["adsets"], message: "Please select at least one adset" });
    }
    if (d.action === "pause_adsets_by_audience" && !d.audiences.length) {
      ctx.addIssue({ code: "custom", path: ["audiences"], message: "Please select at least one audience" });
    }
    if (d.action === "pause_adsets_by_age_range") {
      if (d.age_min == null) ctx.addIssue({ code: "custom", path: ["age_min"], message: "Please select a minimum age" });
      if (d.age_max == null) ctx.addIssue({ code: "custom", path: ["age_max"], message: "Please select a maximum age" });
      if (d.age_min != null && d.age_max != null && d.age_min > d.age_max) {
        ctx.addIssue({ code: "custom", path: ["age_max"], message: "The maximum age cannot be below the minimum age" });
      }
    }
  });
